import React, { Suspense } from 'react'
import Loader from '../../components/spinner'

const ManualContainer = React.lazy(() =>
  import('../../container/payees/add/manual/Manual')
)

const ManualPage = () => (
  <Suspense fallback={<Loader />}>
    <ManualContainer />
  </Suspense>
)

export default ManualPage
